export default __webpack_public_path__ + "static/media/helpdesk.bc26f921.svg";